module.exports = __webpack_public_path__ + "static/media/private_game.51685280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/private_game.png
// module id = 830
// module chunks = 0